module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"briefly":"кратко","detailed":"подробно"}}')
  delete Component.options._Ctor
}
